import createIconsObj from 'common/src/assets/icons/utils/createIconsObj';

const aiVendorIcons = createIconsObj(
  {
    openai: '/openai-icon.png', 
    stabilityai: '/placeholder.svg', // TODO: Replace with actual icon
    clipdrop: '/placeholder.svg', // TODO: Replace with actual icon
    anthropic: '/placeholder.svg', // TODO: Replace with actual icon
    runway: '/placeholder.svg', // TODO: Replace with actual icon
    google: '/gemini-icon.png',
    briaai: '/bria-icon.png', 
  },
  'ai-vendors',
);

export default aiVendorIcons;

